import {Stack} from '@mui/material';
import React, {FC} from 'react';

import {ValueChip} from './value-chip';

interface ArrayValueProps {
  values: unknown[];
  comparedValues?: unknown[];
}

/**
 * Composant pour afficher un tableau de valeurs avec différences
 */
export const ArrayValue: FC<ArrayValueProps> = ({values, comparedValues}) => {
  if (values.length === 0) {
    return <ValueChip value="-" />;
  }

  // Si on a des valeurs à comparer, afficher les différences
  if (Array.isArray(comparedValues)) {
    const added = values.filter((item) => !comparedValues.includes(item));
    const removed = comparedValues.filter((item) => !values.includes(item));
    const unchanged = values.filter((item) => comparedValues.includes(item));

    return (
      <Stack direction="row" spacing={0.5} flexWrap="wrap">
        {unchanged.map((item, idx) => (
          <ValueChip key={`unchanged-${idx}`} value={String(item)} />
        ))}
        {added.map((item, idx) => (
          <ValueChip key={`added-${idx}`} value={String(item)} variant="success" />
        ))}
        {removed.map((item, idx) => (
          <ValueChip key={`removed-${idx}`} value={String(item)} variant="warning" />
        ))}
      </Stack>
    );
  }

  // Affichage simple sans comparaison
  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap">
      {values.map((item, idx) => (
        <ValueChip key={idx} value={String(item)} />
      ))}
    </Stack>
  );
};
